import { connect } from 'react-redux';
import NoProductsState from './index';

const mapStateToProps = () => ({
  venueId: App.config.get('venue').id,
});

// @ts-expect-error ts-migrate(2345) FIXME: Type '{ hasUnsavedChanges: boolean; onClick: null;... Remove this comment to see the full error message
export default connect(mapStateToProps)(NoProductsState);
